let geocoder: google.maps.Geocoder | null = null;

/**
 * Geocodes the given geocoderRequest
 * @param geocoderRequest The geocoder request
 */
export default function geocode(
    geocoderRequest: google.maps.GeocoderRequest,
): Promise<Array<google.maps.GeocoderResult> | null> {
    const promise = new Promise<Array<google.maps.GeocoderResult> | null>((resolve, reject) => {
        if (!geocoder) {
            geocoder = new google.maps.Geocoder();
        }

        geocoder.geocode(
            geocoderRequest,
            function(results: Array<google.maps.GeocoderResult> | null, status: google.maps.GeocoderStatus) {
                if (status === 'OK') {
                    resolve(results);
                } else {
                    reject(status);
                }
            }
        );
    });

    return promise;
};
